export const BLACK_AND_WHITE = "bw";
export const PERFORMER_MODE = "PERFORMER_MODE";
export const JAMMER_MODE = "JAMMER_MODE";
export const BROADCASTER_MODE = "BROADCASTER_MODE";
export const PERFORMER_AND_BROADCASTER = "PERFORMER_AND_BROADCASTER";
export const PERFORMER_WITH_BROADCASTER = "PERFORMER_WITH_BROADCASTER";
export const FULLSCREEN = "fullScreen";
export const AROUND = "around";
export const UNACADEMY = "ua";
